import { useState } from "react";

import { useIntl } from "react-intl";

import {
    EnterpriseTabsWithCards,
    TabsDataType
} from "@/components/enterprise/enterprise-hero-v2/src/enterprise-tabs-with-cards";
import Video from "@/components/wpl/video/src";
import { Modal } from "@/patterns/modal/src";

import { AnalystsTabContent } from "./hero-tab-contents/analysts";
import { EnterpriseTabContent } from "./hero-tab-contents/enterprise";
import { EventsTabContent } from "./hero-tab-contents/events";
import { ProductTabContent } from "./hero-tab-contents/product";

export const ENTERPRISE_HERO_TAB_INTERVAL = 8000;

export const HeroV2Section = () => {
    const intl = useIntl();

    const [tabSwitchInterval, setTabSwitchInterval] = useState<
        number | undefined
    >(ENTERPRISE_HERO_TAB_INTERVAL);

    const [isModalOpen, setIsModalOpen] = useState(false);

    const tabs: TabsDataType = [
        {
            tabComponent: (
                <EnterpriseTabContent
                    handleCtaClick={() => {
                        setIsModalOpen(true);
                        setTabSwitchInterval(undefined);
                    }}
                />
            ),
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.enterprise",
                defaultMessage: "Enterprise"
            }),
            caption: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.enterprise.caption",
                defaultMessage: "Atlassian’s System of Work"
            }),
            englishLabel: "enterprise",
            id: "enterprise"
        },
        {
            tabComponent: <EventsTabContent />,
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.events",
                defaultMessage: "Innovation"
            }),
            caption: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.events.caption",
                defaultMessage: "#1 on Future 50 List"
            }),
            englishLabel: "Innovation",
            id: "innovation"
        },
        {
            tabComponent: <ProductTabContent />,
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.product",
                defaultMessage: "Product"
            }),
            caption: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.product.caption",
                defaultMessage: "Atlassian’s latest AI innovation"
            }),
            englishLabel: "product",
            id: "product"
        },
        {
            tabComponent: <AnalystsTabContent />,
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.analysts",
                defaultMessage: "Analysts"
            }),
            caption: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.analysts.caption",
                defaultMessage: "Gartner Magic Quadrant Leader"
            }),
            englishLabel: "analysts",
            id: "analysts"
        }
    ];

    return (
        <>
            <Modal
                isOpen={isModalOpen}
                closeModal={() => {
                    setIsModalOpen(false);
                    setTabSwitchInterval(ENTERPRISE_HERO_TAB_INTERVAL);
                }}
                content={() => (
                    <Video
                        muted={false}
                        videoType="mp4"
                        videoLink={
                            "https://wac-cdn.atlassian.com/misc-assets/videos/ATLS_SoW_v08_60FPS.mp4"
                        }
                        fallbackText="Introducing Atlassian's System of Work"
                    />
                )}
                closeIconLabel={"Close video"}
            />
            <EnterpriseTabsWithCards
                tabsData={tabs}
                tabSwitchInterval={tabSwitchInterval}
            />
        </>
    );
};
